import { action } from 'typesafe-actions';

import ActionTypes from '../constants/history';

export const historyUndoAction = () => action(ActionTypes.HISTORY_UNDO);

export const historyUndoSuccess = (indice: number) =>
  action(ActionTypes.HISTORY_UNDO_SUCCESS, { indice });

export const historyRedoAction = () => action(ActionTypes.HISTORY_REDO);

export const historyRedoSuccess = (indice: number) =>
  action(ActionTypes.HISTORY_REDO_SUCCESS, { indice });
